<template>
  <div class="">
    <img src="../../assets/img/home-image2.webp" alt="" class="about-image">
    <h3 class="text-title__about">
      Soy Amilcar Coronado,
      <span class="text-span__about">Ingeniero en Sistemas</span>
    </h3>
    <p class="text-paragraph__about">
      Soy un profesional responsable y comprometido. Me gusta tomar en cuenta
      cada detalle a la hora de realizar cualquier proyecto, mientras más
      preciso sea el desarrollo mejor cumple su objetivo. Aprender y mejorar mis
      aptitudes en el ámbito del desarrollo web es un objetivo diario. Soy
      egresado de la Universiad Nor-Oriental Gran Mariscal de Ayacucho,
      Venezuela. De esta universidad aprendí lo que siempre se debe considerar a
      la hora de desarrollar cualquier tipo de software y el desarrollo de
      planificaciones para realizar el proyecto de forma eficiente.
      <br />
      <br />
      Mis conocimientos en el ámbito web dieron inicio con cursos en udemy y
      búsqueda constante de información de forma independiente. Proyectos tanto
      en wordpress/e-commerce como en php o laravel.
    </p>
  </div>
</template>

<script>
export default {
  name: "DescriptionAbout",
};
</script>

<style>
</style>